export default __webpack_public_path__ + "static/media/0051.cae4c15d.png";